import { Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import BaseTable from "../../../components/table/BaseTable";

export const SelectedProductsTable = (props) => {
    const { t } = useTranslation();
    const { products } = props;

    const rows = products.map((product, idx) => ({
        rowId: product.id,
        data: [
            idx + 1,
            product.product_number,
            product.name_full,
            product.num_rooms,
            product.floor,
            product.footage,
        ],
    }));

    const tableHeaders = [
        t("products.SelectedProductsTable.idx"),
        t("products.SelectedProductsTable.productNumber"),
        t("products.SelectedProductsTable.name"),
        t("products.SelectedProductsTable.nRooms"),
        t("products.SelectedProductsTable.floor"),
        t("products.SelectedProductsTable.footage"),
    ];

    return (
        <Paper
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: 2,
                margin: "1rem",
                padding: "1rem",
            }}
        >
            <Typography variant="h3" align="left" sx={{ width: "100%", fontSize: "1.5rem" }}>
                {t("products.SelectedProductsTable.title")}
            </Typography>
            <BaseTable
                stickyHeader={true}
                headers={tableHeaders}
                rows={rows}
                showEditButton={false}
                showDeleteButton={false}
                sortable={false}
                hiddenColumns={[]}
                selectedRows={[]}
            />
        </Paper>
    );
};
